var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-group",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.188V16l-5.078 1.45C1.865 17.754 1 18.9 1 20v1h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13.188V16l5.076 1.45C20.136 17.754 21 18.9 21 20v1H10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7.543c0 3.612-2.688 6.542-6 6.542-3.315 0-6-2.93-6-6.543C5 3.93 7.685 1 11 1c3.312 0 6 2.93 6 6.543z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.938 6.396c-1 1-3.86.952-4.937-1.056-2 2-5.25 2-6.864.86",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 13.188V16l-5.078 1.45C27.865 17.754 27 18.9 27 20v1h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 13.188V16l5.076 1.45C46.136 17.754 47 18.9 47 20v1H36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 7.543c0 3.612-2.688 6.542-6 6.542-3.315 0-6-2.93-6-6.543C31 3.93 33.685 1 37 1c3.312 0 6 2.93 6 6.543z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.906 6.39c-1 1-3.828.958-4.906-1.05-2 2-5.25 2-6.868.86",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 39.21V42l-5.078 1.45C14.865 43.75 14 44.9 14 46v1h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 39.188V42l5.076 1.45C33.136 43.752 34 44.9 34 46v1H23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33.542c0 3.614-2.688 6.544-6 6.544-3.315 0-6-2.93-6-6.544C18 29.93 20.685 27 24 27c3.312 0 6 2.93 6 6.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.906 32.34c-1 1-3.828 1.008-4.906-1-2 2-5.25 2-6.868.86",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 25l5 5m27-5l-5 5",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.1d230a8db3796ecf5d1c2b9b15973100.svg";
export { ForwardRef as ReactComponent };